import { createRouter, createWebHashHistory } from 'vue-router'
import NProgress from 'nprogress'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'

const router = createRouter({
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    //mode: "history", // isto seria para tirar o cardinal do url!
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'home',
            // VB:REPLACE-NEXT-LINE:ROUTER-REDIRECT
            redirect: '/Dashboard',
            component: MainLayout,
            meta: {
                authRequired: true,
                hidden: true,
            },
            children: [

                // VB:REPLACE-START:ROUTER-CONFIG

                /****************************************************************************
                 * Dashboard
                 * */
                {
                    path: '/Dashboard',
                    meta: { title: 'Dashboard' },
                    name: 'Dashboard',
                    component: () => import('./views/Dashboard/dashboard'),
                    disabled: false,
                },

                /****************************************************************************
                 * Minhas Informações
                 * */
                {
                    path: 'Rh/minhas-informacoes',
                    meta: { title: 'Minhas Informações' },
                    name: 'MinhasInformacoes',
                    component: () => import('./views/Informacoes/MinhasInformacoes'),
                    disabled: false,
                },


                /****************************************************************************
                 * Recursos Humanos
                 * */

                // Lista de pedidos para realizar
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos',
                    meta: { title: 'Novo pedido' },
                    name: 'ListaNovosPedidos',
                    component: () => import('./views/Rh/ListaNovosPedidos'),
                    disabled: false,
                },



                // Pedido de férias
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/ferias',
                    meta: { title: 'Novo pedido de férias' },
                    name: 'PedidoPedidoFerias',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFerias'),
                    disabled: false,
                },

                // Pedido de alteração férias
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/alteracao-ferias',
                    meta: { title: 'Novo pedido de alteração de férias' },
                    name: 'PedidoPedidoAlteracaoFerias',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAlteracaoFerias'),
                    disabled: false,
                },



                // COMUNICAÇÃO DE FALTA(S) AO TRABALHO
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/faltas',
                    meta: { title: 'Nova comunicação de faltas ao Trabalho' },
                    name: 'PedidoComunicacaoFaltas',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFaltas'),
                    disabled: false,
                },
                // COMUNICAÇÃO DE FALTA(S) AO TRABALHO POR CONTA DAS FÉRIAS
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/faltas-feria',
                    meta: { title: 'Nova comunicação de faltas ao Trabalho por conta das férias' },
                    name: 'PedidoComunicacaoFaltasFerias',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFaltasFerias'),
                    disabled: false,
                },
                // COMUNICAÇÃO DE FALTA(S) AO TRABALHO POR DOENÇA
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/faltas-doenca',
                    meta: { title: 'Nova comunicação de faltas ao trabalho por doença' },
                    name: 'PedidoComunicacaoFaltasDoenca',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFaltasDoenca'),
                    disabled: false,
                },
                // Compensação do Trabalho Prestado em Acréscimo | COMUNICAÇÃO DE FALTA(S) AO TRABALHO por COMPENSAÇÃO DE TEMPO
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/faltas-compensacao-tempo',
                    meta: { title: 'Compensação do trabalho prestado em acréscimo' },
                    name: 'NovoPedidoFaltasCompensacaoTempo',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFaltasCompensacaoTempo'),
                    disabled: false,
                },
                // COMUNICAÇÃO - Apresentação ao serviço 
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/apresentacao-servico',
                    meta: { title: 'Novo pedido para a comunicação de apresentação ao serviço' },
                    name: 'NovoPedidoApresentacaoServico',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoApresentacaoServico'),
                    disabled: false,
                },
                // COMUNICAÇÃO DE FALTA(S) AO TRABALHO
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/faltas-injustificadas',
                    meta: { title: 'Nova comunicação de faltas injustificadas ao Trabalho', requerResponsavel: true },
                    name: 'PedidoComunicacaoFaltasInjustificadas',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFaltasInjustificadas'),
                    disabled: false,
                },



                // Pedido de trabalho suplementar
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/trabalho-suplementar',
                    meta: { title: 'Novo pedido de autorização para realização de trabalho suplementar' },
                    name: 'PedidoTrabalhoSuplementar',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoTrabalhoSuplementar'),
                    disabled: false,
                },
                // Pedido de trabalho suplementar - Urgencia
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/trabalho-suplementar-urgente',
                    meta: { title: 'Novo pedido de autorização para realização de trabalho suplementar. Para situações não previstas, trabalhos com caracter de urgência.' },
                    name: 'PedidoTrabalhoSuplementarUrgente',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoTrabalhoSuplementarUrgente'),
                    disabled: false,
                },



                // COMUNICAÇÃO - GOZO DE DESCANSO COMPENSATÓRIO POR PRESTAÇÃO DE TRABALHO EM DIA DE DESCANSO SEMANAL OBRIGATÓRIO (DOMINGO)
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/descanso-compensatorio-trab-domingo',
                    meta: { title: 'Novo pedido para a comunicação do Gozo de Descanso Compensatório por Prestação de Trabalho em Dia de Descanso Semanal Obrigatório (Domingo)' },
                    name: 'NovoPedidoComunicacaoDescasoCompensatorioTrabDomingo',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoComunicacaoDescasoCompensatorioTrabDomingo'),
                    disabled: false,
                },


                // PEDIDO DE FORMAÇÃO PROFISSIONAL
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/formacao-profissional',
                    meta: { title: 'Novo pedido para formação profissional' },
                    name: 'NovoPedidoFormacaoProfissional',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFormacaoProfissional'),
                    disabled: false,
                },

                // PEDIDO DE AJUDAS DE CUSTO E TRANSPORTE
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/ajudas-custo-transporte',
                    meta: { title: 'Novo pedido de ajudas de custo e transporte' },
                    name: 'NovoPedidoAjudasCustoTransporte',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAjudasCustoTransporte'),
                    disabled: false,
                },
                
                // PROTEÇÃO PARENTALIDADE
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/protecao-parentalidade',
                    meta: { title: 'Novo pedido de proteção parentalidade' },
                    name: 'NovoPedidoProtecaoParentalidade',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoProtecaoParentalidade'),
                    disabled: false,
                },



                // acumulação de funçõe
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/acumulacao-funcoes',
                    meta: { title: 'Pedido para autorização de acumulação de funções' },
                    name: 'NovoPedidoAcumulacaoFuncoes',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAcumulacaoFuncoes'),
                    disabled: false,
                },
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/acumulacao-funcoes-cessacao',
                    meta: { title: 'Pedido para a comunicação de cessação de acumulação de funções' },
                    name: 'NovoPedidoAcumulacaoFuncoesCessacao',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAcumulacaoFuncoesCessacao'),
                    disabled: false,
                },
                {
                    path: '/Rh/Pedidos/lista-novos-pedidos/acumulacao-funcoes-alteracao',
                    meta: { title: 'Pedido para a alteração da autorização de acumulação de funções' },
                    name: 'NovoPedidoAcumulacaoFuncoesAlteracao',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAcumulacaoFuncoesAlteracao'),
                    disabled: false,
                },

                // Pedido de trabalho suplementar - Engano
                /*{
                    path: '/Rh/Pedidos/novo/trabalho-suplementar-engano',
                    meta: { title: 'Novo pedido de autorização para realização de trabalho suplementar. Para situações de esquecimento ou engano do registo do pedido Autorização para realização de trabalho suplementar.' },
                    name: 'PedidoTrabalhoSuplementarEngano',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoTrabalhoSuplementarEngano'),
                    disabled: true,
                },*/

                // Pedido de atualização de dados pessoais
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoAtualizacaoDadosPessoais',
                    meta: { title: 'Novo pedido para a atualização de dados pessoais' },
                    name: 'PedidoAtualizacaoDadosPessoais',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAtualizacaoDadosPessoais'),
                    disabled: true,
                },*/

                // Pedido de declaração de assistência familiar
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoAssistenciaFamiliar',
                    meta: { title: 'Novo pedido para a declaração de assistencia familiar' },
                    name: 'PedidoAssistenciaFamiliar',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAssistenciaFamiliar'),
                    disabled: true,
                },*/

                // Pedido de Alteração de número de identificação bancária - IBAN
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoAtualizacaoIdentificacaoBancaria',
                    meta: { title: 'Novo pedido de alteração de número de identificação bancária - IBAN' },
                    name: 'NovoPedidoAtualizacaoIdentificacaoBancaria',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAtualizacaoIdentificacaoBancaria'),
                    disabled: true,
                },*/

                // Pedido para comunicação de faltas injustificadas ao trabalho
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoFaltasInjustificadas',
                    meta: { title: 'Novo pedido para comunicação de faltas injustificadas ao trabalho' },
                    name: 'NovoPedidoFaltasInjustificadas',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFaltasInjustificadas'),
                    disabled: true,
                },*/

                // PEDIDO DE ABONO DE FAMÍLIA PARA CRIANÇAS E JOVENS / ABONO PRÉ-NATAL
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoAbonoFamilia',
                    meta: { title: 'Novo pedido de abono de família para crianças e jovens / Abono pré-natal' },
                    name: 'NovoPedidoAbonoFamilia',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAbonoFamilia'),
                    disabled: true,
                },*/

                // ABONO DE FAMÍLIA PARA CRIANÇAS E JOVENS - PEDIDO DE REAVALIAÇÃO DO ESCALÃO DE RENDIMENTOS
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoReavaliacaoEscalaoRendimentos',
                    meta: { title: 'Novo pedido de reavaliação do escalão de rendimentos' },
                    name: 'NovoPedidoReavaliacaoEscalaoRendimentos',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoReavaliacaoEscalaoRendimentos'),
                    disabled: true,
                },*/

               
            
                // COMUNICAÇÃO DE FALTA(S) AO TRABALHO (Medida Emprego Apoiado em Mercado Aberto)
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoComunicacaoFaltasMercadoAberto',
                    meta: { title: 'Novo pedido de comunicação de faltas ao trabalha (Medida emprego apoiado em mercado aberto)' },
                    name: 'NovoPedidoComunicacaoFaltasMercadoAberto',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoComunicacaoFaltasMercadoAberto'),
                    disabled: true,
                },*/

                // COMUNICAÇÃO DO ESTADO DE DOENÇA (CGA)
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoFeriasMercadoAberto',
                    meta: { title: 'Pedido de férias (Medida Emprego Apoiado em Mercado Aberto)' },
                    name: 'NovoPedidoFeriasMercadoAberto',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoFeriasMercadoAberto'),
                    disabled: true,
                },*/

                // PEDIDO DE FÉRIAS (Medida Emprego Apoiado em Mercado Aberto)
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoComunicacaoEstadoDoenca',
                    meta: { title: 'Novo pedido para a comunicação do estado de doença (CGA)' },
                    name: 'NovoPedidoComunicacaoEstadoDoenca',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoComunicacaoEstadoDoenca'),
                    disabled: true,
                },*/

                // COMUNICAÇÃO DA COMPOSIÇÃO DO AGREGADO FAMILIAR - IRS
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoComunicacaoAgregadoFamiliar',
                    meta: { title: 'Novo pedido para a comunicação agregado familiar (IRS)' },
                    name: 'NovoPedidoComunicacaoAgregadoFamiliar',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoComunicacaoAgregadoFamiliar'),
                    disabled: true,
                },*/

                // COMUNICAÇÃO DE ACIDENTE DE TRABALHO
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoComunicacaoAcidenteTrabalho',
                    meta: { title: 'Novo pedido para a comunicação de acidente de trabalho' },
                    name: 'NovoPedidoComunicacaoAcidenteTrabalho',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoComunicacaoAcidenteTrabalho'),
                    disabled: true,
                },*/

                // PEDIDO DE ANULAÇÃO DE ABONOS/DESCONTOS
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoAnulacaoAbonoDescontos',
                    meta: { title: 'Novo pedido para a anulação de abonos/descontos' },
                    name: 'NovoPedidoAnulacaoAbonoDescontos',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoAnulacaoAbonoDescontos'),
                    disabled: true,
                },*/

                // PEDIDO DE CONCESSÃO/MANUTENÇÃO DO ESTATUTO TRABALHADOR-ESTUDANTE
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoEstatutoTrabalhadorEstudante',
                    meta: { title: 'Novo pedido para a concessão/manutenção do estatuto trabalhador-estudante' },
                    name: 'NovoPedidoEstatutoTrabalhadorEstudante',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoEstatutoTrabalhadorEstudante'),
                    disabled: true,
                },*/

                // PROTEÇÃO DA PARENTALIDADE (Medida Emprego Apoiado em Mercado Aberto)
                /*{
                    path: '/Rh/Pedidos/novo/NovoPedidoProtecaoParentalidadeMercadoAberto',
                    meta: { title: 'Novo pedido de proteção da Parentalidade (Medida Emprego Apoiado em Mercado Aberto)' },
                    name: 'NovoPedidoProtecaoParentalidadeMercadoAberto',
                    component: () => import('./views/Rh/Pedidos/NovoPedidoProtecaoParentalidadeMercadoAberto'),
                    disabled: true,
                },*/


             


                /****************************************************************************
                 * Mapas de férias
                 * */

                // Consultar férias marcadas
                {
                    path: '/Rh/mapa-ferias',
                    meta: { title: 'Mapa de férias' },
                    name: 'MapaFerias',
                    component: () => import('./views/Rh/Mapas/MapaFerias'),
                    disabled: false,
                },

                // Consultar férias marcadas por unidade
                {
                    path: '/Rh/mapa-ferias-v2',
                    meta: { title: 'Mapa de férias por unidade' },
                    name: 'MapaFeriasV2',
                    component: () => import('./views/Rh/Mapas/MapaFerias_v2'),
                    disabled: false,
                },


                /****************************************************************************
                 * Escolas
                 * */
                // Módulo de ausências ao trabalho no Portal do Colaborador
                /*{
                    path: '/Escolas/escolas-registo-ausencias',
                    meta: { title: 'Módulo de registo ausências ao trabalho' },
                    name: 'RegistoAusenciaTrabalho',
                    component: () => import('./views/Escolas/RegistoAusenciaTrabalho'),
                    disabled: true,
                },*/


                /****************************************************************************
                 * Assiduidade
                 * */
                // Link exterior para a Assiduidade


                /****************************************************************************
                 * Meus Pedidos
                 * */
                {
                    path: '/meuspedidos/Pedidos',
                    meta: { title: 'Os meus pedidos' },
                    name: 'ListaMeusPedidos',
                    component: () => import('./views/MeusPedidos/ListaMeusPedidos'),
                    disabled: false,
                },


                // Ver pedido
                {
                    //path: '/Rh/Pedidos/ver/pedido/',
                    path: '/meuspedidos/VerPedido',
                    name: 'VerPedido',
                    meta: { title: 'Consultar pedido' },
                    component: () => import('./views/MeusPedidos/VerPedido'),
                    props: true,
                    disabled: true,
                },


                /****************************************************************************
                 * Minhas tarefas 
                 * */
                // Lista de tarefas por realizar
                {
                    path: '/Tarefas/lista-tarefas',
                    meta: { title: 'Tarefas por realizar' },
                    name: 'ListaTarefasPendentes',
                    component: () => import('./views/Tarefas/ListaTarefas'),
                    disabled: false,
                },

                // Ver tarefa
                {
                    //path: '/tarefas/ver-tarefa/:id/:nifSelecionado/:timestamp?',
                    path: '/tarefas/ver-tarefa',
                    name: 'VerTarefa',
                    meta: { title: 'Executar tarefa' },
                    component: () => import('./views/Tarefas/VerTarefa'),
                    props: true,
                    disabled: false,
                },


                /****************************************************************************
                 * RGPD
                 * */
                {
                    path: '/Rgpd/Pedidos/novo',
                    meta: { title: 'Novo fomrulário de incidente de segurança de dados pessoais' },
                    name: 'NovoPedidoIncidenteSegurancaDadosPessoais',
                    component: () => import('./views/Rgpd/Pedidos'),
                    disabled: true,
                },

                /****************************************************************************
                 * ...
                 * */



                // VB:REPLACE-END:ROUTER-CONFIG

            ],
        },

        // System Pages
        {
            path: '/auth',
            component: AuthLayout,
            redirect: 'auth/login',
            children: [
                {
                    path: '/auth/404',
                    name: 'route404',
                    meta: {
                        title: 'Error 404',
                    },
                    component: () => import('./views/auth/404'),
                },
                {
                    path: '/auth/500',
                    meta: {
                        title: 'Error 500',
                    },
                    component: () => import('./views/auth/500'),
                },
                {
                    path: '/auth/login',
                    name: 'login',
                    meta: {
                        title: 'MFA - Autenticação',
                    },
                    component: () => import('./views/auth/login'),
                },


                /*{
                    path: '/auth/login/MFALogin',
                    name: 'MFALogin',
                    meta: {
                        title: 'Sign In MFA',
                    },
                    component: () => import('./views/auth/login/MFALogin'),
                },*/
                {
                    path: '/auth/login/MFASubmit',
                    name: 'MFASubmit',
                    meta: {
                        title: 'MFA - Validação',
                    },
                    component: () => import('./components/Auth/Login/MFASubmit.vue'),
                },


                {
                    path: '/auth/register',
                    meta: {
                        title: 'Sign Up',
                    },
                    component: () => import('./views/auth/register'),
                },
                {
                    path: '/auth/forgot-password',
                    meta: {
                        title: 'Forgot Password',
                    },
                    component: () => import('./views/auth/forgot-password'),
                },
                {
                    path: '/auth/lockscreen',
                    meta: {
                        title: 'Lockscreen',
                    },
                    component: () => import('./views/auth/lockscreen'),
                },
            ],
        },

        // Redirect to 404
        {
            path: '/:pathMatch(.*)*',
            redirect: { name: 'route404' },
        },
    ],
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    setTimeout(() => {
        NProgress.done()
    }, 300)

    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.user.authorized) {
            next({
                path: '/auth/login',
                query: { redirect: to.fullPath },
            })
        } else if (to.meta.requerResponsavel && store.state.user.uo_responsavel == 0) {
            next({
                path: '/Rh/Pedidos/lista-novos-pedidos',
                query: { redirect: to.fullPath },
            })
        }  else {
            next()
        }
    } else {
        next()
    }
})

export default router